<!-- 联报活动详情 -->
<template>
  <div class="acvitity_detail">
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '100%' }"
      duration="0.18"
      close-icon-position="top-left"
      @click-close-icon="close"
    >
      <!--v-if="show"  未点击联报入口，不初始化联报详情 -->
      <div class="jointPreferencesDetail" v-if="show">
        <!-- 标题 -->
        <h1 class="title">
          <div class="title-text">
            <img
              src="../../assets/img/components/wechatBinding/icon_close.png"
              @click="close()"
              alt=""
            />
            <span>联报优惠</span>
            <span class="empty-span"></span>
          </div>
        </h1>
        <div class="course_info">
          <!-- 默认已选课程 -->
          <h2 class="course_info_title">当前课程</h2>
          <div class="defaultSelectCourse" v-for="(item, index) in courseCatalog" :key="index">
            <div v-if="item.child.length && item.categoryName === 'defaultSelect'">
              <JointPreferencesCard
                v-for="(child, index) in item.child"
                :courseInfo="child"
                :key="index"
                @triggerSku="receiveSku"
                class="defaultSelectCourse"
              />
            </div>
          </div>
          <!-- 可选课程列表 -->
          <h2 class="course_info_title">可选课程</h2>
          <div class="discount_info" v-if="activityData">
            <span class="discount-text">{{ String(activityData.unionDiscounts) }}</span>
          </div>
          <!-- {{courseCatalog}} -->
          <div class="course_list">
            <div class="course_list_box" v-for="(item, index) in courseCatalog" :key="index">
              <div v-if="item.child.length && item.categoryName !== 'defaultSelect'">
                <h3 class="course_list_box_title">
                  <span></span><b>{{ item.categoryName }}</b>
                </h3>
                <JointPreferencesCard
                  v-for="(child, index) in item.child"
                  :courseInfo="child"
                  :key="index"
                  @triggerSku="receiveSku"
                  @triggerChecked="receiveCourse"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 底部按钮 -->
        <footer class="foot">
          <!-- 优惠描述 -->
          <div class="foot_discount_info">
            <div class="discount_content">
              <template v-if="this.discountPrice && this.fullDiscountPrice">
                <span>已享受联报，满减优惠</span
                ><b>￥{{ (this.discountPrice + this.fullDiscountPrice).toFixed(2) }}</b>
              </template>
              <template v-else-if="this.discountPrice">
                <span>已享受联报优惠</span><b>￥{{ this.discountPrice }}</b>
              </template>
              <template v-else>
                {{ String(activityData.unionDiscounts) }}
              </template>
            </div>
          </div>
          <!-- fix 按钮 -->
          <div class="foot_btn">
            <div class="foot_btn_left">
              <div class="price">
                <template v-if="!this.discountPrice">
                  <span>￥</span><b>{{ calculationPrice(orderTotalPrice).b }} </b
                  ><span>{{ calculationPrice(orderTotalPrice).s }}</span>
                </template>
                <template v-else>
                  <span>￥</span><b>{{ calculationPrice(totalPrice).b }}</b
                  ><span>{{ calculationPrice(totalPrice).s }}</span>
                </template>
              </div>
              <div class="num">
                <div v-if="selectCourse.length > 1">
                  已选<b>{{ selectCourse.length }}</b
                  >个
                </div>
                <span v-else>选购产品参与优惠活动吧～</span>
                <div class="secondSKillTips" v-show="skillFlag">
                  (秒杀课程不参与其他优惠)
                </div>
              </div>
            </div>
            <div class="foot_btn_right">
              <button @click="jumpBuy">
                {{ selectCourse.length === 1 ? '购买单科' : '联报购买' }}
              </button>
            </div>
          </div>
        </footer>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { gioPlatform, priceCount, setTokenFromCookie } from '@/utils/tools';

import JointPreferencesCard from './jointPreferencesCourseCard.vue';
import { reqPrice } from '../../api/pay/index';

export default {
  components: {
    JointPreferencesCard,
  },

  data() {
    return {
      show: false,
      courseCatalog: [
        {
          categoryName: 'defaultSelect',
          child: [],
        },
        {
          categoryName: '数学',
          child: [],
        },
        {
          categoryName: '英语',
          child: [],
        },
        {
          categoryName: '政治',
          child: [],
        },
        {
          categoryName: '专业课',
          child: [],
        },
      ], // 所有的课程及类目 类目固定且按此顺序排序
      selectCourse: [], // 已勾的课程列表
      totalPrice: 0, // 应付总额
      discountPrice: 0, // 优惠总额
      actionType: 0, // 1登录后跳转订单页
      fullDiscountPrice: 0, // 满减优惠的金额
      orderTotalPrice: 0, // 订单原价
      skillFlag: false, // 是否显示秒杀不参与优惠的文案
      gioList: [], // 用于gio埋点
    };
  },
  props: {
    showAcvitity: {
      type: Boolean,
      default: false,
    },
    // 默认选中的产品
    // eg: [{ productId: 604,skuId: 700}]
    defaultSelectCourse: {
      type: Array,
      default: () => [],
    },
    // 联报活动数据
    // eg: {maxUnionDiscountPrice:100,promotionProductRespList:[],unionDiscountWriting:'',unionDiscounts:[]}
    activityData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
  },
  watch: {
    show(status) {
      if (!status) {
        Object.assign(this.$data, this.$options.data());
        return;
      }
      this.dealCourseCatalog(this.activityData.promotionProductRespList);
    },
  },
  mounted() {},
  methods: {
    close() {
      this.show = false;
      this.$emit('close', true);
    },
    // 价格小数位
    calculationPrice(price) {
      return priceCount(price);
    },
    // 合并相同类目+排序
    dealCourseCatalog(list) {
      // console.log(list, 198)
      // console.log(this.allAcvitity, 176);
      const defaultSelectCourse = JSON.stringify(this.defaultSelectCourse);
      // console.log(defaultSelectCourse)
      const defaultSelectCourseIdArr = [];
      this.defaultSelectCourse.forEach((item) => {
        defaultSelectCourseIdArr.push(item.productId);
      });
      list.forEach((course) => {
        this.courseCatalog.forEach((name) => {
          // console.log(name, defaultSelectCourse, 3366);
          // console.log(
          //   course.productId,
          //   defaultSelectCourse.indexOf(course.productId),
          //   name.categoryName === 'defaultSelect',
          // );
          const courseIds = [];
          this.defaultSelectCourse.forEach((item) => {
            courseIds.push(item.productId);
          });
          // 默认选中的课程+sku
          if (courseIds.includes(course.productId) && name.categoryName === 'defaultSelect') {
            Object.assign(course, {
              selected: true, // 选中状态
              skuInfo: course.productDetailUnionPromotionSkuResp.find(
                (sku) => defaultSelectCourse.indexOf(sku.skuId) > -1,
              ), // 选中的sku
            });
            name.child.push(course);
          }
          // 可选类目+课程
          if (defaultSelectCourseIdArr.indexOf(course.productId) === -1) {
            if (course.categoryName === name.categoryName) {
              name.child.push(course);
            }
          }
        });
      });
      this.getPrice();
    },
    // 接收sku，将sku存入对应的课程中
    receiveSku(data) {
      const { skuDesc, action } = data;
      const courseCatalog = JSON.parse(JSON.stringify(this.courseCatalog));
      courseCatalog.forEach((item) => {
        item.child.forEach((child) => {
          const skuInfo = child.productDetailUnionPromotionSkuResp.find(
            (sku) => sku.skuId === skuDesc.skuId,
          );
          if (skuInfo) {
            this.$set(child, 'skuInfo', skuDesc);
          }
        });
      });
      this.courseCatalog = courseCatalog;
      if (action === 1) {
        this.getPrice();
      }
    },
    // 接收Card组件选中或取消的课程
    receiveCourse(course, checked) {
      this.courseCatalog.forEach((item) => {
        item.child.forEach((child) => {
          const tempChild = child;
          if (child.productId === course.productId && checked) {
            tempChild.selected = true;
          }
          if (child.productId === course.productId && !checked) {
            tempChild.selected = false;
          }
        });
      });
      this.getPrice();
    },
    // 联报计价,返回优惠后的金额
    async getPrice() {
      // 已选中的课程
      const coureList = [];
      this.courseCatalog.forEach((item) => {
        item.child.forEach((child) => {
          if (child.selected) {
            coureList.push({
              productId: child.productId,
              skuId: child.skuInfo.skuId,
            });
          }
        });
      });
      // req
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: 1,
          platform: 2,
        },
        promotionProductSkuPriceList: coureList,
      });
      if (res.code === 0) {
        this.gioList = res.data;
        const {
          productCalculateResultRespList,
          orderPayPrice,
          unionDiscountPrice,
          fullDiscountPrice,
        } = res.data;
        this.totalPrice = orderPayPrice;
        this.orderTotalPrice = orderPayPrice;
        this.fullDiscountPrice = fullDiscountPrice;
        this.discountPrice = unionDiscountPrice;
        this.selectCourse = productCalculateResultRespList;
        // 将每个课程优惠后的价格赋值到courseCatalog中child
        const courseCatalog = JSON.parse(JSON.stringify(this.courseCatalog));
        courseCatalog.forEach((child) => {
          child.child.forEach((children) => {
            Object.assign(children, { currPrice: 999999 });
            productCalculateResultRespList.forEach((item) => {
              if (item.productId === children.productId && children.selected) {
                Object.assign(children, { currPrice: item.currPrice });
                // if (!unionDiscountPrice) {
                //   Object.assign(children, { currPrice: item.originalPrice });
                // } else {
                //   Object.assign(children, { currPrice: item.currPrice });
                // }
              }
            });
          });
        });
        this.courseCatalog = courseCatalog;

        const skillList = res.data.singleCalculateResultRespList
          ? res.data.singleCalculateResultRespList
          : null;
        if (skillList) {
          // eslint-disable-next-line
          skillList.some(item => {
            if (item.promotionLabel === 2 || item.promotionLabel === 3) {
              this.skillFlag = true;
              return true; // 跳出循环
            }
            this.skillFlag = false;
          });
        } else {
          this.skillFlag = false;
        }
      }
    },
    // 订单
    jumpBuy() {
      /**
       * 区分app
       * 校验登录
       */
      const { isApp = false } = this.$root.$data;
      if (this.userInfo.id) {
        this.jumpPayOrder();
      } else if (isApp) {
        this.$sendToApp('login', {}, true).then(async () => {
          setTokenFromCookie();
          await this.$root.getUserInfo();
          this.jumpPayOrder();
        });
      } else {
        const param = this.selectCourse.map((product) => ({
          productId: product.productId,
          skuId: product.skuId,
        }));
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/payOrder', product: JSON.stringify(param) },
        });
      }
    },
    jumpPayOrder() {
      const query = this.selectCourse.map((product) => ({
        productId: product.productId,
        skuId: product.skuId,
      }));
      if (this.$router?.currentRoute?.path.includes('/payOrder')) {
        this.$emit('unionConfirm', query);
        return;
      }
      const { liveRoomId } = this.$route.query;
      if (this.$root.$data.isApp) {
        this.$sendToApp('buyCourseNew', { product: JSON.stringify(query), liveRoomId }, false);
        this.gioDefault();
        return;
      }
      this.$router.push({
        path: 'payOrder',
        query: {
          product: JSON.stringify(query),
          liveRoomId,
        },
      });
      this.gioDefault();
    },
    async gioDefault() {
      const courseIdList = [];
      const courseNameList = [];
      const allianceId = [];
      const allianceName = [];
      const fullReductionId = [];
      const fullReductionName = [];
      const secondsKillNameList = [];
      const {
        orderPayPrice,
        orderTotalPrice,
        productCalculateResultRespList,
        fullDiscountPrice,
        unionDiscountPrice,
        unionCalculateResultRespList,
        promotionFullCalculateResultRespList,
        singleCalculateResultRespList,
      } = this.gioList;
      productCalculateResultRespList.forEach((element) => {
        courseIdList.push(element.productId);
        courseNameList.push(element.productName);
      });
      if (unionDiscountPrice) {
        unionCalculateResultRespList.forEach((element) => {
          allianceId.push(element.promotionId);
          allianceName.push(element.promotionName);
        });
      }
      if (fullDiscountPrice) {
        promotionFullCalculateResultRespList.forEach((element) => {
          fullReductionId.push(element.promotionId);
          fullReductionName.push(element.promotionName);
        });
      }
      if (singleCalculateResultRespList) {
        singleCalculateResultRespList.forEach((element) => {
          if (element.promotionLabel === 2 || element.promotionLabel === 3) {
            secondsKillNameList.push(element.promotionName);
          }
        });
      }
      // 立即购买埋点
      // eslint-disable-next-line
      gio('track', 'buyCourse_event', {
        courseIdList_var: courseIdList.toString(), // 课程 ID 列表
        courseNameList_var: courseNameList.toString(), // 课程名称列表
        courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
        isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
        allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
        allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
        allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
        isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
        secondsKillNameList_var:
          secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
        isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
        fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
        fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
        fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.acvitity_detail {
  width: 100%;
  height: 100%;
}
.discount_content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #787878;
  font-size: 25px;
  line-height: 72px;
  text-align: center;

  span {
    color: #787878;
    font-size: 25px;
  }
  b {
    color: #ff6c02;
    font-size: 25px;
  }
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 192px;
  background: #fff;
  .foot_discount_info {
    // padding: 0 36px;
    box-sizing: border-box;
    width: 100%;
    height: 72px;
    overflow: hidden;
    background: #fff0e6;

    p {
      width: 678px;
      margin: 0 auto;
      overflow: hidden;
      color: #ff6c02;
      font-size: 22px;
      line-height: 72px;
      white-space: nowrap;
      text-align: center;
      text-overflow: ellipsis;
    }
    .discount_content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      line-height: 72px;
      text-align: center;

      span {
        color: #787878;
        font-size: 25px;
      }
      b {
        color: #ff6c02;
        font-size: 25px;
      }
    }
  }
  .foot_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 120px;
    padding: 0 36px;
    background: #fff;
    .foot_btn_left {
      .num {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-top: 5px;
        p {
          color: #787878;
          font-size: 22px;
        }
        b {
          color: #ff6c02;
          font-weight: 400;
          font-size: 22px;
        }
        span {
          color: #787878;
          font-size: 22px;
        }
        div {
          font-size: 22px;
        }
        .secondSKillTips {
          margin-left: 12px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
        }
      }
      .price {
        display: flex;
        align-items: flex-end;
        width: 100%;
        span {
          color: #ff6e13;
          font-weight: 500;
          font-size: 22px;
        }
        b {
          color: #ff6e13;
          font-weight: 500;
          font-size: 36px;
        }
      }
    }
    .foot_btn_right {
      display: flex;
      button {
        width: 235px;
        height: 81px;
        color: #fff;
        font-size: 29px;
        line-height: 81px;
        text-align: center;
        background: #ff6c02;
        border: none;
        border-radius: 44px;
      }
    }
  }
}
.jointPreferencesDetail {
  padding: 60px 0 220px 0;
  background: #f9f9f9;
  .title {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    width: 100%;
    background: #f9f9f9;
    .title-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 43px 34px;

      img {
        width: 36px;
        height: 36px;
      }

      span {
        color: #000;
        font-weight: 500;
        font-size: 36px;
        text-align: center;
      }
    }
  }
  .course_info {
    padding: 43px 36px 0 36px;
    .course_info_title {
      padding: 36px 0 21px 0;
      color: #333;
      font-weight: 500;
      font-size: 33px;
    }
    .discount_info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 14px 36px;
      background: #fff1e6;
      border-radius: 14px;
      .discount-text {
        color: #ff6c02;
        font-size: 22px;
        line-height: 31px;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
    .course_list {
      .course_list_box {
        .course_list_box_title {
          display: flex;
          align-items: center;
          margin-top: 36px;

          span {
            display: inline-block;
            width: 5px;
            height: 25px;
            background: #ff6c02;
            border-radius: 3px;
          }
          b {
            padding-left: 8px;
            color: #333;
            font-weight: 500;
            font-size: 29px;
          }
        }
      }
    }
  }
}
::v-deep .defaultSelectCourse {
  .jointPreferencesCard .check {
    display: none;
  }
  .jointPreferencesCard {
    .right_price,
    .times {
      pointer-events: none;
    }
  }
}
</style>
